// src/components/HomePage/Section3/styles.js
import styled from 'styled-components';

export const Container = styled.section`
  background-color: #f9f9f9;
  padding: 5rem 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
`;

export const ContentContainer = styled.div`
  display: flex;
  max-width: 1200px;
  width: 100%;
  gap: 3rem;
  align-items: center;
  
  @media (max-width: 1024px) {
    flex-direction: column;
  }
`;

export const AppInterface = styled.div`
  flex: 1;
  max-width: 500px;
  background-color: white;
  border-radius: 20px;
  padding: 2rem;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.05);
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background-color: #FF9500;
    opacity: 0.1;
    top: -30px;
    right: 20%;
    z-index: 0;
  }
  
  &::after {
    content: '';
    position: absolute;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: #2563EB;
    opacity: 0.1;
    bottom: -20px;
    left: 15%;
    z-index: 0;
  }
`;

export const IconCircle = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: #2563EB;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 1.5rem;
`;

export const IconText = styled.span`
  color: white;
  font-weight: 600;
  font-size: 1rem;
`;

export const QuestionBox = styled.div`
  background-color: #f5f5f5;
  border-radius: 12px;
  padding: 1.2rem;
  margin-bottom: 1.5rem;
`;

export const QuestionText = styled.p`
  color: #272643;
  font-size: 1.1rem;
  line-height: 1.4;
  margin: 0;
`;

export const ImageContainer = styled.div`
  width: 100%;
  max-height: 300px;
  height: auto;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 1.5rem;
`;

export const CertificationImageme = styled.img`
  width: 100%;
  height: auto; // Mantém a proporção original
  display: block;
`;


export const ResponseBubble = styled.div`
  background-color: #E9F7FC;
  border-radius: 12px;
  padding: 1rem;
  width: fit-content;
`;

export const ResponseText = styled.p`
  color: #2563EB;
  font-size: 0.9rem;
  margin: 0;
`;

export const PromotionalContent = styled.div`
  flex: 1;
  max-width: 500px;
`;

export const MainTitle = styled.h2`
  font-size: 2.5rem;
  color: #272643;
  margin-bottom: 1.5rem;
  line-height: 1.3;
  font-weight: 700;
`;

export const Subtitle = styled.p`
  color: #4D4D4D;
  font-size: 1.1rem;
  line-height: 1.6;
  margin-bottom: 2.5rem;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  gap: 1rem;
  
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const PrimaryButton = styled.button`
  background-color: #2563EB;
  color: white;
  font-weight: 600;
  padding: 1rem 2rem;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.3s;
  
  &:hover {
    background-color: #1c51c7;
  }
`;

export const SecondaryButton = styled.button`
  background-color: white;
  color: #2563EB;
  font-weight: 600;
  padding: 1rem 2rem;
  border: 2px solid #2563EB;
  border-radius: 8px;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s;
  
  &:hover {
    background-color: #E9F7FC;
  }
`;
